import { http } from '@/utils/http';
import qs from 'qs';

const baseUrl = 'vote/2020project/2020economics/controller.php?enews=';
// 列表
export const getBaseInfo = () => {
  return http.get(`${baseUrl}base-info`);
};

// 列表
export const voteList = (page: number , awards: number , search?: any) => {
  return http.get(`${baseUrl}vote-list&page=` + page + '&search=' + search + '&awards=' + awards );
};

// 获取详情页数据
export const getDetailData = (id: number) => {
  return http.get(`${baseUrl}detail&id=` + id);
};
